module.exports = __webpack_public_path__ + "img/Optical-Timeseries.2eeaf33a.png";